import RootState from '../../../typings/RootState'
import { Event } from '../../types/event'
import { AreaList } from './types'

export const selectAreaList = (state: RootState): AreaList =>
  state.adminArea.AreaList

export const selectEvent = (state: RootState): Event => state.adminArea.Event
